import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import styles from '@/styles/TestimonialSlider.module.css';
import { useReviews } from '@/hooks/useReviews';

export default function TestimonialSlider() {
  const { reviews, isLoading } = useReviews();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (reviews.length <= 1 || isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((current) => (current + 1) % reviews.length);
    }, 8000); // Changed to 8000ms (8 seconds)

    return () => clearInterval(interval);
  }, [reviews.length, isPaused]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  if (isLoading) {
    return <div className={styles.loading}>Loading testimonials...</div>;
  }

  if (!reviews.length) {
    return null;
  }

  return (
    <div 
      className={styles.sliderContainer}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className={styles.slider}>
        {reviews.map((review, index) => (
          <div
            key={review.id}
            className={`${styles.slide} ${index === currentIndex ? styles.active : ''}`}
          >
            <div className={styles.rating}>
              {'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}
            </div>
            <p className={styles.quote}>{review.review_text}</p>
            <div className={styles.author}>
              <p><strong>{review.name}</strong></p>
            </div>
          </div>
        ))}
      </div>

      {reviews.length > 1 && (
        <div className={styles.dots}>
          {reviews.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}

      <div className={styles.viewAllReviews}>
        <Link
          href="/reviews"
          className={styles.textLink}
          aria-label="View all testimonials and reviews, and share your own story"
          title="Browse all reviews and submit your own testimonial"
        >
          View All Reviews & Share Your Story <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
} 